// GrillsConfiguration.js - Main entry point for Grills Configuration
// This component renders the tabbed interface for managing all grills-related data
import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';

// Import all tab components
import GrillTypesTab from './GrillTypesTab';
import GrillSizesTab from './GrillSizesTab';
import GrillPatternsTab from './GrillPatternsTab';
import GrillInternalColorsTab from './GrillInternalColorsTab';
import GrillExternalColorsTab from './GrillExternalColorsTab';
import GrillSizeTypesTab from './GrillSizeTypesTab';
import GrillPatternsSimpleTab from './GrillPatternsSimpleTab';

const GrillsConfiguration = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    { label: 'Grill Types', component: <GrillTypesTab /> },
    { label: 'Grill Sizes', component: <GrillSizesTab /> },
    { label: 'Grill Patterns', component: <GrillPatternsTab /> },
    { label: 'Grill Internal Colors', component: <GrillInternalColorsTab /> },
    { label: 'Grill External Colors', component: <GrillExternalColorsTab /> },
    { label: 'Grill Size Types', component: <GrillSizeTypesTab /> },
    { label: 'Grill Patterns Simple', component: <GrillPatternsSimpleTab /> },
  ];

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={activeTab}
        onChange={(e, newValue) => setActiveTab(newValue)}
        sx={{ mb: 2 }}
        variant="scrollable"
        scrollButtons="auto"
      >
        {tabs.map((tab, index) => (
          <Tab key={index} label={tab.label} />
        ))}
      </Tabs>

      {tabs[activeTab]?.component}
    </Box>
  );
};

export default GrillsConfiguration;
